// extracted by mini-css-extract-plugin
export default {"banner":"OurValues_banner__QaCKS","content":"OurValues_content__Z9+rB","text":"OurValues_text__IEPid","image":"OurValues_image__3suNk"};